import React from "react"
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material"
import { Link } from "react-router-dom"
import FarmEnvroData from "../../components/Charts/FarmEnvroData"
// import AddFarmObservation from "../../components/Observations/AddFarmObservation"

export default function FarmSummary({ activeFarmDetails }) {
  // const [addingObservation, setAddingObservation] = useState(false)
  return (
    <>
      {/* <AddFarmObservation
        id={activeFarmDetails.id}
        open={addingObservation}
        setOpen={setAddingObservation}
      /> */}
      <Card>
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {activeFarmDetails.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {activeFarmDetails.description || "No description"}
          </Typography>
          <FarmEnvroData activeFarmDetails={activeFarmDetails} />
        </CardContent>
        <CardActions>
          <Button
            size="small"
            component={Link}
            to={`/farm/${activeFarmDetails.id}`}
          >
            View Farm
          </Button>
          <Button
            size="small"
            component={Link}
            to={`/farm/${activeFarmDetails.id}`}
          >
            Add Observation
          </Button>
        </CardActions>
      </Card>
    </>
  )
}
